module.exports = __webpack_public_path__ + "img/graphql-stencil.ba9271e9.svg";